import * as Sentry from "@sentry/vue";
import { createPinia } from "pinia";
import { createApp } from "vue";
// @ts-ignore
import VueMatomo from "vue-matomo";

import App from "./App.vue";
import { i18n } from "./globals/i18n.ts";
import router from "./globals/router.ts";
import { auth0Plugin } from "./store/useAuth.ts";

const app = createApp(App);

if (import.meta.env.PROD) {
  Sentry.init({
    app,
    environment: import.meta.env.VITE_STAGE,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration({ router })],
    tracesSampleRate: 0.5,
    tracePropagationTargets: [window.origin],
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: {
        request: { deny: ["forwarded", "-ip", "remote-", "via", "-user"] },
        response: { deny: ["forwarded", "-ip", "remote-", "via", "-user"] },
      },
      httpBodies: [],
      urlQueryParams: { deny: ["forwarded", "-ip", "remote-", "via", "-user"] },
      genAI: { inputs: false, outputs: false },
      databaseQueryData: false,
      graphQL: { document: false, variables: false },
    },
  });
}

app.use(i18n);
app.use(createPinia());
app.use(router);

// According to https://github.com/auth0/auth0-vue/blob/a8b8752b82e273cfdcdea334ef2dd8158b69027b/EXAMPLES.md?plain=1#L405, the router must be registered before the auth0 plugin.
app.use(auth0Plugin);

if (import.meta.env.VITE_STAGE === "prod") {
  app.use(VueMatomo.default, {
    host: "https://used.dpa.com",
    siteId: 13,
    router,
    preInitActions: [["requireCookieConsent"]],
  });
}

app.mount("#app");
